import styled from 'styled-components';

export const CardItems = styled.div`
  font-size: .8em;
  border-radius: 7px;
  background-color: var(--white);
  padding: 30px;
  cursor: pointer;

  -webkit-box-shadow: 0px 0px 5px -4px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px -4px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px -4px rgba(0, 0, 0, 0.75);

  h1 {
    font-size: 1em;
  }

  @media (min-width: 64.5em) {
    font-size: .9em;
  }  
`;

export const HeaderCard = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  svg {
    margin-right: 10px;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-gap: 10px;

  @media (min-width: 30.5em) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;

  svg{
    margin-right: 5px;
  }
`;